module.exports = __webpack_public_path__ + "0966bfd8404c4499e518c4d16bc79a20.svg";